module.exports = __webpack_public_path__ + "img/resell-inrego.43212028.png";